/**
 * Ear Training Suite URL-param parsers. v1.5 adds:
 *   - `?mode=aug-dim-warmup` as a third sub-mode option.
 *   - `?direction=<ascending|descending|harmonic|mixed>` (interval-only;
 *     silently ignored elsewhere — the welcome screen owns that gating).
 * Unknown / missing values return `null` so the welcome screen renders with
 * no pre-selection (user must pick).
 *
 * Spec: docs/superpowers/specs/2026-05-21-ear-training-v15-design.md §7
 */
export type SubMode = 'interval' | 'quality' | 'aug-dim-warmup'

export type DirectionParam = 'ascending' | 'descending' | 'harmonic' | 'mixed'

export const parseSubMode = (raw: string | null): SubMode | null => {
  if (raw === 'interval' || raw === 'quality' || raw === 'aug-dim-warmup') {
    return raw
  }
  return null
}

export const parseDirection = (raw: string | null): DirectionParam | null => {
  if (raw === 'ascending' || raw === 'descending' || raw === 'harmonic' || raw === 'mixed') {
    return raw
  }
  return null
}
